import { isDefined } from "@clipboard-health/util-ts";
import { type Place } from "@src/appV2/redesign/Onboarding/OnboardingFlowContainer/AddressStep/types";

import { SUPPORTED_COUNTRY_CODES } from "../constants";

const SUPPORTED_COUNTRY_CODES_SET = new Set<string>(SUPPORTED_COUNTRY_CODES);

export function isValidPlace(place: Place | Partial<Place>): place is Place {
  return isDefined(place?.address) && isDefined(place?.location);
}

export function isSupportedCountryCode(countryCode: string | undefined): boolean {
  return isDefined(countryCode) && SUPPORTED_COUNTRY_CODES_SET.has(countryCode);
}
